/* eslint-disable */
import { h, Component } from 'preact';

class IconError extends Component {
    render() {
        const { width = 15, height = 13 } = this.props;

        return (
            <div>
                <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.988 10.716a.71.71 0 0 1-.484.181.738.738 0 0 1-.493-.178c-.139-.12-.209-.289-.209-.504 0-.188.067-.348.202-.48a.671.671 0 0 1 .491-.198c.194 0 .359.067.495.198a.638.638 0 0 1 .206.48c0 .214-.068.38-.208.501m-.93-6.386a.598.598 0 0 1 .439-.178c.171 0 .318.06.44.178.12.11.186.264.183.426L7.942 8.16a.398.398 0 0 1-.132.318.458.458 0 0 1-.307.117.458.458 0 0 1-.312-.114.398.398 0 0 1-.135-.32l-.177-3.404c0-.167.06-.31.18-.426M14 10.743L8.668 1.542c-.276-.48-.693-.79-1.169-.792-.476.001-.892.313-1.167.792L1 10.742c-.164.278-.25.559-.25.832-.002.338.148.66.413.868.264.206.615.308 1.019.308h10.637c.403 0 .754-.102 1.018-.308.264-.209.416-.53.413-.868 0-.273-.089-.554-.25-.832"
                        fill="#B10043"
                        fillRule="nonzero"
                    />
                </svg>
            </div>

        );
    }
}

export default IconError;
